import { render, staticRenderFns } from "./txt-secondary.vue?vue&type=template&id=22e749ad&scoped=true&"
import script from "./txt-secondary.vue?vue&type=script&lang=js&"
export * from "./txt-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e749ad",
  null
  
)

export default component.exports